import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-stock-bill.reducer';

export const PharmacyStockBillDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyStockBillEntity = useAppSelector(state => state.pharmacyStockBill.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyStockBillDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.detail.title">PharmacyStockBill</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockBillEntity.id}</dd>
          <dt>
            <span id="billNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.billNumber">Bill Number</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockBillEntity.billNumber}</dd>
          <dt>
            <span id="billDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.billDate">Bill Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockBillEntity.billDate}</dd>
          <dt>
            <span id="totalCost">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.totalCost">Total Cost</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockBillEntity.totalCost}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockBillEntity.discount}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockBillEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockBillEntity.cursor}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockBillEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockBillEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockBillEntity.lastupdated}</dd>
          <dt>
            <span id="cgst">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.cgst">Cgst</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockBillEntity.cgst}</dd>
          <dt>
            <span id="sgst">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.sgst">Sgst</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockBillEntity.sgst}</dd>
          <dt>
            <span id="roundOffVal">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.roundOffVal">Round Off Val</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockBillEntity.roundOffVal}</dd>
          <dt>
            <span id="shipmentId">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.shipmentId">Shipment Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockBillEntity.shipmentId}</dd>
          <dt>
            <span id="addedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.addedById">Added By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockBillEntity.addedById}</dd>
          <dt>
            <span id="modifiedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.modifiedById">Modified By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockBillEntity.modifiedById}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockBillEntity.addedByType}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockBillEntity.modifiedByType}</dd>
          <dt>
            <span id="margin">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.margin">Margin</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockBillEntity.margin}</dd>
          <dt>
            <span id="cessAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.cessAmount">Cess Amount</Translate>
            </span>
            <UncontrolledTooltip target="cessAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.help.cessAmount" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyStockBillEntity.cessAmount}</dd>
          <dt>
            <span id="amended">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.amended">Amended</Translate>
            </span>
            <UncontrolledTooltip target="amended">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.help.amended" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyStockBillEntity.amended ? 'true' : 'false'}</dd>
          <dt>
            <span id="statusDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.statusDate">Status Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockBillEntity.statusDate}</dd>
          <dt>
            <span id="receivedDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.receivedDate">Received Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockBillEntity.receivedDate}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{pharmacyStockBillEntity.pharmacy ? pharmacyStockBillEntity.pharmacy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.pharmacySuppliers">Pharmacy Suppliers</Translate>
          </dt>
          <dd>{pharmacyStockBillEntity.pharmacySuppliers ? pharmacyStockBillEntity.pharmacySuppliers.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.pharmacist">Pharmacist</Translate>
          </dt>
          <dd>{pharmacyStockBillEntity.pharmacist ? pharmacyStockBillEntity.pharmacist.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.amendedFrom">Amended From</Translate>
          </dt>
          <dd>{pharmacyStockBillEntity.amendedFrom ? pharmacyStockBillEntity.amendedFrom.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.amendedTo">Amended To</Translate>
          </dt>
          <dd>{pharmacyStockBillEntity.amendedTo ? pharmacyStockBillEntity.amendedTo.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.invoiceType">Invoice Type</Translate>
          </dt>
          <dd>{pharmacyStockBillEntity.invoiceType ? pharmacyStockBillEntity.invoiceType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.approvalStatus">Approval Status</Translate>
          </dt>
          <dd>{pharmacyStockBillEntity.approvalStatus ? pharmacyStockBillEntity.approvalStatus.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.statusSettingPharmacy">Status Setting Pharmacy</Translate>
          </dt>
          <dd>{pharmacyStockBillEntity.statusSettingPharmacy ? pharmacyStockBillEntity.statusSettingPharmacy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-stock-bill" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-stock-bill/${pharmacyStockBillEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyStockBillDetail;
